import React from "react";
import { useAuth } from "@/context/AuthContext";
import { ShieldWarning, SignOut } from "@phosphor-icons/react";

export default function AccessRestricted({ reason, area }) {
  const { user, logout } = useAuth();
  const areaLabel =
    area === "sales"
      ? "Sales workspace"
      : area === "invoice"
      ? "Finance workspace"
      : area === "inventory"
      ? "Inventory workspace"
      : "this workspace";
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-slate-50"
      data-testid="access-restricted"
    >
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-lg p-8 text-center">
        <div className="mx-auto w-14 h-14 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mb-5">
          <ShieldWarning size={28} weight="duotone" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">
          Access Restricted
        </h1>
        <p className="text-sm text-slate-500 mt-2">
          You don&apos;t have permission to view {areaLabel}.
        </p>
        {reason && (
          <p className="text-xs text-slate-500 mt-3 italic">{reason}</p>
        )}
        <div className="mt-5 px-4 py-3 bg-slate-50 border border-slate-100 rounded-md text-left">
          <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-1">
            Signed in as
          </div>
          <div className="text-sm font-medium text-slate-900">{user?.name}</div>
          <div className="text-xs text-slate-500 truncate">{user?.email}</div>
        </div>
        <p className="text-xs text-slate-500 mt-5">
          Need access? Ask an admin to add{" "}
          <span className="font-mono">{user?.email}</span> on the User Roles page.
        </p>
        <button
          onClick={logout}
          className="mt-6 inline-flex items-center gap-2 px-4 h-10 rounded-md border border-slate-200 bg-white text-slate-700 text-sm font-medium hover:bg-slate-50"
          data-testid="restricted-signout"
        >
          <SignOut size={14} /> Sign out and use a different account
        </button>
      </div>
    </div>
  );
}
